(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hewn-features-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-hewn-features]');
    roots.forEach(function (root) {
      const track = root.querySelector('[data-hf-track]');
      const slides = root.querySelectorAll('[data-hf-slide]');
      const dots = root.querySelectorAll('[data-hf-dot]');
      const prev = root.querySelector('[data-hf-prev]');
      const next = root.querySelector('[data-hf-next]');
      if (!track || !slides.length) return;

      function scrollToIndex(i) {
        const target = slides[i];
        if (!target) return;
        track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }

      function currentIndex() {
        let bestIdx = 0;
        let bestDist = Infinity;
        const scrollLeft = track.scrollLeft;
        slides.forEach(function (s, i) {
          const dist = Math.abs((s.offsetLeft - track.offsetLeft) - scrollLeft);
          if (dist < bestDist) { bestDist = dist; bestIdx = i; }
        });
        return bestIdx;
      }

      function updateDots() {
        const idx = currentIndex();
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
          d.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        });
      }

      if (prev) prev.addEventListener('click', function () {
        scrollToIndex(Math.max(0, currentIndex() - 1));
      });
      if (next) next.addEventListener('click', function () {
        scrollToIndex(Math.min(slides.length - 1, currentIndex() + 1));
      });

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () { scrollToIndex(i); });
      });

      let scrollTimer = null;
      track.addEventListener('scroll', function () {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(updateDots, 80);
      }, { passive: true });

      updateDots();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hewn-product-buy"]) return;
  try {
    
  (function () {
    const roots = document.querySelectorAll('[data-hewn-buy]');

    roots.forEach(function (root) {
      // ── Gallery thumbnails ↔ main slide
      const slides = root.querySelectorAll('[data-hb-slide]');
      const thumbs = root.querySelectorAll('[data-hb-thumb]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          const idx = parseInt(t.getAttribute('data-hb-thumb'), 10);
          slides.forEach(function (s, i) {
            s.classList.toggle('is-active', i === idx);
          });
          thumbs.forEach(function (b, i) {
            b.classList.toggle('is-active', i === idx);
            b.setAttribute('aria-selected', i === idx ? 'true' : 'false');
          });
        });
      });

      // ── Quantity +/-
      const qtyInput = root.querySelector('[data-hb-qty-input]');
      const qtyBtns = root.querySelectorAll('[data-hb-qty]');
      qtyBtns.forEach(function (b) {
        b.addEventListener('click', function () {
          const delta = parseInt(b.getAttribute('data-hb-qty'), 10);
          const cur = parseInt(qtyInput.value, 10) || 1;
          const next = Math.max(1, cur + delta);
          qtyInput.value = next;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      // ── Variant picker (radio) → update hidden id + price
      const variantData = (function () {
        const tag = root.querySelector('[data-hb-variants-json]');
        if (!tag) return [];
        try { return JSON.parse(tag.textContent); } catch (e) { return []; }
      })();
      const optionInputs = root.querySelectorAll('[data-hb-option]');
      const variantIdInput = root.querySelector('[data-hb-variant-id]');
      const priceWrap = root.querySelector('[data-hb-price]');
      const atc = root.querySelector('[data-hb-atc]');

      function formatMoney(cents) {
        const v = (cents / 100).toFixed(2);
        return '$' + v;
      }

      function pickedOptionValues() {
        const groups = {};
        optionInputs.forEach(function (inp) {
          const pos = inp.getAttribute('data-hb-option');
          if (inp.checked) groups[pos] = inp.value;
        });
        return [groups['1'], groups['2'], groups['3']].filter(function (v) { return v !== undefined; });
      }

      function matchVariant() {
        const picked = pickedOptionValues();
        if (!picked.length) return null;
        return variantData.find(function (v) {
          for (let i = 0; i < picked.length; i++) {
            if (v.options[i] !== picked[i]) return false;
          }
          return true;
        }) || null;
      }

      function updateLabels() {
        optionInputs.forEach(function (inp) {
          const label = inp.closest('.hewn-buy__variant-option');
          if (label) label.classList.toggle('is-selected', inp.checked);
        });
      }

      function refreshFromVariant(v) {
        if (!v) return;
        if (variantIdInput) variantIdInput.value = v.id;
        if (priceWrap) {
          let html = '<span class="hewn-buy__price-current' + (v.compare_at_price > v.price ? ' hewn-buy__price-current--on-sale' : '') + '">' + formatMoney(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html += '<s class="hewn-buy__price-compare">' + formatMoney(v.compare_at_price) + '</s>';
          }
          priceWrap.innerHTML = html;
        }
        if (atc) {
          atc.disabled = !v.available;
          const lbl = atc.querySelector('.hewn-buy__atc-label');
          if (lbl) lbl.textContent = v.available ? (lbl.dataset.in || lbl.textContent) : 'Sold out';
        }
        // Update URL ?variant= for shareability without reload
        if (window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      optionInputs.forEach(function (inp) {
        inp.addEventListener('change', function () {
          updateLabels();
          const v = matchVariant();
          refreshFromVariant(v);
        });
      });

      updateLabels();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
